const PREFAB_THUMB_WIDTH = 112;
const PREFAB_THUMB_HEIGHT = 92;

// The long side grows with world size, compressed so small prefabs stay visible and big ones fit.
export const prefabThumbnailScale = (width, height) => {
    width = Math.max(width, 1);
    height = Math.max(height, 1);
    const longSide = Math.max(width, height);
    return Math.min(6 * longSide ** 0.45 / longSide, PREFAB_THUMB_WIDTH / width, PREFAB_THUMB_HEIGHT / height);
};
